export async function addCardToStripe(paymentDetailsRef, failOnEmptyCard) {
  await paymentDetailsRef.current.submitEmailCC();
  const { addCardInputRef } = paymentDetailsRef.current;
  const { forwardedCardElementRef } = addCardInputRef.current;
  return await forwardedCardElementRef.current.submitCreditCardToStripe(failOnEmptyCard);
}

export default addCardToStripe;
